import React from 'react';

export interface Primer3TabProps {
  basesChanged: boolean;
}

export default function Primer3Tab({basesChanged}: Primer3TabProps): JSX.Element {
  return (
    <>
      {basesChanged ? (
        <div className="buffer-tab">
          <div className="alert alert-warning">
            The Primer3 results are out of date since the sequence's bases have changed. Please re-run the
            primer wizard to generate new primers. (Primers you've already saved haven't been affected.)
          </div>
        </div>
      ) : (
        <table className="table table-condensed primers-table">
          <thead>
            <tr>
              <th>
                <input type="checkbox" className="select-all" />
              </th>
              <th className="text-center">
                Penalty
                <a className="glyphicon glyphicon-question-sign" />
              </th>
              <th>Direction</th>
              <th className="text-center">% GC</th>
              <th className="text-center">
                T<sub>m</sub>&deg;C
              </th>
              <th className="text-center">Location</th>
              <th className="text-center">Length</th>
              <th className="text-center">Product BP</th>
              <th>Primer</th>
              <th />
            </tr>
          </thead>
        </table>
      )}
    </>
  );
}
